import { render, staticRenderFns } from "./forbidden.vue?vue&type=template&id=7f4e0169&scoped=true&"
import script from "./forbidden.vue?vue&type=script&lang=js&"
export * from "./forbidden.vue?vue&type=script&lang=js&"
import style0 from "./forbidden.vue?vue&type=style&index=0&id=7f4e0169&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4e0169",
  null
  
)

export default component.exports